<template>
    <el-dialog
            title="服务设置"
            :visible.sync="setShow"
            :close-on-click-modal="false"
            width="1200px"
            ref="dialog"
            top="5vh"
            @close="setClose"
    >
        <div class="ServiceSetting" v-loading="loading">
            <div class="Set">
                <div class="Set-top">
                    <div class="d-title">【{{serviceOffer.id}}】{{serviceOffer.serviceName}}</div>
                </div>
                <div class="Set-center">
                    <table>
                        <tr class="font-999">
                            <td>领域</td>
                            <td>一级产品</td>
                            <td>二级产品</td>
                            <td>三级产品</td>
                            <td>服务类型</td>
                            <td>类别</td>
                        </tr>
                        <tr class="font-666">
                            <td>{{serviceOffer.productDomainName}}</td>
                            <td>{{serviceOffer.oneProductName}}</td>
                            <td>{{serviceOffer.twoProductName}}</td>
                            <td>{{serviceOffer.threeProductName}}</td>
                            <td>{{serviceOffer.serviceStageName}}</td>
                            <td>{{serviceOffer.serviceType==1?'标准服务':'项目服务'}}</td>
                        </tr>
                    </table>
                </div>
                <div style="margin: 20px 42px 20px 0;">
                    <el-tabs v-model="Serviceparam.priceSettingType">
                        <el-tab-pane label="发单方" name="0" disabled></el-tab-pane>
                        <el-tab-pane label="接单方" name="1" disabled></el-tab-pane>
                    </el-tabs>
                </div>
                <div class="Set-bottom">
                    <el-form ref="form2" :model="billData" label-width="130px">
                        <el-form-item label="结算方式：" prop="settleType">
                            <el-radio-group v-model="settleType">
                                <el-radio :disabled="Number(Serviceparam.priceSettingType) == 1" :label="0">按天结算</el-radio>
                                <el-radio :disabled="Number(Serviceparam.priceSettingType) == 1" :label="1">按小时结算</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <template v-if="settleType==0">
                            <el-row :gutter="24">
                                <el-col :lg="12">
                                    <el-form-item label="工作日价格：" prop="workdayPrice">
                                        <div class="d_flex">
                                            <el-input v-model.trim="billData.workdayPrice" @blur="regulartest('billData.workdayPrice')"></el-input>
                                            <div>元/天/人</div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <!-- <el-col :lg="12">
                                    <el-form-item label="工作日会员价：" prop="vipWorkdayPrice">
                                        <div class="d_flex">
                                            <el-input v-model.trim="billData.vipWorkdayPrice" @blur="regulartest('billData.vipWorkdayPrice')"></el-input>
                                            <div>元/天/人</div>
                                        </div>
                                    </el-form-item>
                                </el-col> -->
                            </el-row>
                            <el-row :gutter="24">
                                <el-col :lg="12">
                                    <el-form-item label="周末价格：" prop="weekendPrice">
                                        <div class="d_flex">
                                            <el-input v-model.trim="billData.weekendPrice" @blur="regulartest('billData.weekendPrice')"></el-input>
                                            <div>元/天/人</div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <!-- <el-col :lg="12">
                                    <el-form-item label="周末会员价：" prop="vipWeekendPrice">
                                        <div class="d_flex">
                                            <el-input v-model.trim="billData.vipWeekendPrice" @blur="regulartest('billData.vipWeekendPrice')"></el-input>
                                            <div>元/天/人</div>
                                        </div>
                                    </el-form-item>
                                </el-col> -->
                            </el-row>
                            <el-row :gutter="24">
                                <el-col :lg="12">
                                    <el-form-item label="节假日价格：" prop="holidayPrice">
                                        <div class="d_flex">
                                            <el-input v-model.trim="billData.holidayPrice" @blur="regulartest('billData.holidayPrice')"></el-input>
                                            <div>元/天/人</div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <!-- <el-col :lg="12">
                                    <el-form-item label="节假日会员价：" prop="vipHolidayPrice">
                                        <div class="d_flex">
                                            <el-input v-model.trim="billData.vipHolidayPrice" @blur="regulartest('billData.vipHolidayPrice')"></el-input>
                                            <div>元/天/人</div>
                                        </div>
                                    </el-form-item>
                                </el-col> -->
                            </el-row>
                        </template>
                        <template v-if="settleType==1">
                            <el-row :gutter="24">
                                <el-col :lg="24">
                                    <el-form-item label="工作日价格：">
                                        <div class="d_flex">
                                            <div class="mar-r-22">出发</div>
                                            <el-input  v-model.trim="billConfiguration.workdayDepartHourPrice" @blur="regulartest('billConfiguration.workdayDepartHourPrice')"></el-input>
                                            <div class="mar-r-22">元 / 小时 / 人</div>
                                            <div class="mar-r-22">工作</div>
                                            <el-input v-model.trim="billConfiguration.workdayWorkHourPrice" @blur="regulartest('billConfiguration.workdayWorkHourPrice')"></el-input>
                                            <div class="mar-r-22">元 / 小时 / 人</div>
                                            <div class="mar-r-22">返程</div>
                                            <el-input v-model.trim="billConfiguration.workdayBackHourPrice" @blur="regulartest('billConfiguration.workdayBackHourPrice')"></el-input>
                                            <div>元 / 小时 / 人</div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="24">
                                <el-col :lg="24">
                                    <el-form-item label="周末价格：" >
                                        <div class="d_flex">
                                            <div class="mar-r-22">出发</div>
                                            <el-input v-model.trim="billConfiguration.weekendDepartHourPrice" @blur="regulartest('billConfiguration.weekendDepartHourPrice')"></el-input>
                                            <div class="mar-r-22">元 / 小时 / 人</div>
                                            <div class="mar-r-22">工作</div>
                                            <el-input v-model.trim="billConfiguration.weekendWorkHourPrice" @blur="regulartest('billConfiguration.weekendWorkHourPrice')"></el-input>
                                            <div class="mar-r-22">元 / 小时 / 人</div>
                                            <div class="mar-r-22">返程</div>
                                            <el-input v-model.trim="billConfiguration.weekendBackHourPrice" @blur="regulartest('billConfiguration.weekendBackHourPrice')"></el-input>
                                            <div>元 / 小时 / 人</div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="24">
                                <el-col :lg="24">
                                    <el-form-item label="节假日价格：" >
                                        <div class="d_flex">
                                            <div class="mar-r-22">出发</div>
                                            <el-input  v-model.trim="billConfiguration.holidayDepartHourPrice" @blur="regulartest('billConfiguration.holidayDepartHourPrice')"></el-input>
                                            <div class="mar-r-22">元 / 小时 / 人</div>
                                            <div class="mar-r-22">工作</div>
                                            <el-input  v-model.trim="billConfiguration.holidayWorkHourPrice" @blur="regulartest('billConfiguration.holidayWorkHourPrice')"></el-input>
                                            <div class="mar-r-22">元 / 小时 / 人</div>
                                            <div class="mar-r-22">返程</div>
                                            <el-input v-model.trim="billConfiguration.holidayBackHourPrice" @blur="regulartest('billConfiguration.holidayBackHourPrice')"></el-input>
                                            <div>元 / 小时 / 人</div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <!-- <el-row :gutter="24">
                                <el-col :lg="24">
                                    <el-form-item label="工作日会员价：" >
                                        <div class="d_flex">
                                            <div class="mar-r-22">出发</div>
                                            <el-input  v-model.trim="billConfiguration.vipWorkdayDepartHourPrice" @blur="regulartest('billConfiguration.vipWorkdayDepartHourPrice')"></el-input>
                                            <div class="mar-r-22">元 / 小时 / 人</div>
                                            <div class="mar-r-22">工作</div>
                                            <el-input  v-model.trim="billConfiguration.vipWorkdayWorkHourPrice" @blur="regulartest('billConfiguration.vipWorkdayWorkHourPrice')"></el-input>
                                            <div class="mar-r-22">元 / 小时 / 人</div>
                                            <div class="mar-r-22">返程</div>
                                            <el-input v-model.trim="billConfiguration.vipWorkdayBackHourPrice" @blur="regulartest('billConfiguration.vipWorkdayBackHourPrice')"></el-input>
                                            <div>元 / 小时 / 人</div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="24">
                                <el-col :lg="24">
                                    <el-form-item label="周末会员价：" >
                                        <div class="d_flex">
                                            <div class="mar-r-22">出发</div>
                                            <el-input v-model.trim="billConfiguration.vipWeekendDepartHourPrice" @blur="regulartest('billConfiguration.vipWeekendDepartHourPrice')"></el-input>
                                            <div class="mar-r-22">元 / 小时 / 人</div>
                                            <div class="mar-r-22">工作</div>
                                            <el-input  v-model.trim="billConfiguration.vipWeekendWorkHourPrice" @blur="regulartest('billConfiguration.vipWeekendWorkHourPrice')"></el-input>
                                            <div class="mar-r-22">元 / 小时 / 人</div>
                                            <div class="mar-r-22">返程</div>
                                            <el-input  v-model.trim="billConfiguration.vipWeekendBackHourPrice" @blur="regulartest('billConfiguration.vipWeekendBackHourPrice')"></el-input>
                                            <div>元 / 小时 / 人</div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="24">
                                <el-col :lg="24">
                                    <el-form-item label="节假日会员价：" >
                                        <div class="d_flex">
                                            <div class="mar-r-22">出发</div>
                                            <el-input v-model.trim="billConfiguration.vipHolidayDepartHourPrice" @blur="regulartest('billConfiguration.vipHolidayDepartHourPrice')"></el-input>
                                            <div class="mar-r-22">元 / 小时 / 人</div>
                                            <div class="mar-r-22">工作</div>
                                            <el-input  v-model.trim="billConfiguration.vipHolidayWorkHourPrice" @blur="regulartest('billConfiguration.vipHolidayWorkHourPrice')"></el-input>
                                            <div class="mar-r-22">元 / 小时 / 人</div>
                                            <div class="mar-r-22">返程</div>
                                            <el-input  v-model.trim="billConfiguration.vipHolidayBackHourPrice" @blur="regulartest('billConfiguration.vipHolidayBackHourPrice')"></el-input>
                                            <div>元 / 小时 / 人</div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row> -->
                        </template>
                        <el-row :gutter="24">
                            <el-col :lg="24">
                                <el-form-item label="工作日加班价格：" prop="isWorkdayHasOvertimeSetting">
                                    <div class="d_flex">
                                        <el-radio-group v-model="commData.isWorkdayHasOvertimeSetting" class="mar-r-45"
                                                        @change="changeTime(commData.isWorkdayHasOvertimeSetting,'commData.workdayOverTimeBefore','commData.workdayOverTimeAfter')">
                                            <el-radio :label="false">无</el-radio>
                                            <el-radio :label="true">有</el-radio>
                                        </el-radio-group>
                                        <template v-if="commData.isWorkdayHasOvertimeSetting">
                                            <el-time-picker
                                                    v-model="commData.workdayOverTimeBefore"
                                                    value-format= "HH:mm:ss"
                                                    placeholder="选择时间"
                                            >
                                            </el-time-picker>
                                            <div class="mar-r-22">以前</div>
                                            <el-time-picker
                                                    v-model="commData.workdayOverTimeAfter"
                                                    value-format= "HH:mm:ss"
                                                    placeholder="选择时间">
                                            </el-time-picker>
                                            <div class="mar-r-40">以后</div>
                                            <div>加班价格：</div>
                                            <el-input v-model.trim="commData.workdayOverTimeHourPrice" @blur="regulartest('commData.workdayOverTimeHourPrice')"></el-input>
                                            <div>元/小时/人</div>
                                        </template>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :lg="24">
                                <el-form-item label="周末加班价格：" prop="isWeekendHasOvertimeSetting">
                                    <div class="d_flex">
                                        <el-radio-group v-model="commData.isWeekendHasOvertimeSetting" class="mar-r-45"
                                                        @change="changeTime(commData.isWeekendHasOvertimeSetting,'commData.weekendOverTimeBefore','commData.weekendOverTimeAfter')">
                                            <el-radio :label="false">无</el-radio>
                                            <el-radio :label="true">有</el-radio>
                                        </el-radio-group>
                                        <template v-if="commData.isWeekendHasOvertimeSetting">
                                            <el-time-picker
                                                    v-model="commData.weekendOverTimeBefore"
                                                    value-format= "HH:mm:ss"
                                                    placeholder="选择时间"
                                            >
                                            </el-time-picker>
                                            <div class="mar-r-22">以前</div>
                                            <el-time-picker
                                                    v-model="commData.weekendOverTimeAfter"
                                                    value-format= "HH:mm:ss"
                                                    placeholder="选择时间">
                                            </el-time-picker>
                                            <div class="mar-r-40">以后</div>
                                            <div>加班价格：</div>
                                            <el-input  v-model.trim="commData.weekendOverTimeHourPrice" @blur="regulartest('commData.weekendOverTimeHourPrice')"></el-input>
                                            <div>元/小时/人</div>
                                        </template>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :lg="24">
                                <el-form-item label="节假日加班价格：" prop="isHolidayHasOvertimeSetting">
                                    <div class="d_flex">
                                        <el-radio-group v-model="commData.isHolidayHasOvertimeSetting" class="mar-r-45"
                                                        @change="changeTime(commData.isHolidayHasOvertimeSetting,'commData.holidayOverTimeBefore','commData.holidayOverTimeAfter')">
                                            <el-radio :label="false">无</el-radio>
                                            <el-radio :label="true">有</el-radio>
                                        </el-radio-group>
                                        <template v-if="commData.isHolidayHasOvertimeSetting">
                                            <el-time-picker
                                                    v-model="commData.holidayOverTimeBefore"
                                                    value-format= "HH:mm:ss"
                                                    placeholder="选择时间">
                                            </el-time-picker>
                                            <div class="mar-r-22">以前</div>
                                            <el-time-picker
                                                    v-model="commData.holidayOverTimeAfter"
                                                    value-format= "HH:mm:ss"
                                                    placeholder="选择时间">
                                            </el-time-picker>
                                            <div class="mar-r-40">以后</div>
                                            <div>加班价格：</div>
                                            <el-input v-model.trim="commData.holidayOverTimeHourPrice" @blur="regulartest('commData.holidayOverTimeHourPrice')"></el-input>
                                            <div>元/小时/人</div>
                                        </template>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <template v-if="settleType == 1">
                            <el-form-item label="扣除1小时价格：">
                                <div class="d_flex">
                                    <el-radio-group v-model="billConfiguration.isDeductOneHourPrice" class="mar-r-45">
                                        <el-radio :label="true">是</el-radio>
                                        <el-radio :label="false">否</el-radio>
                                    </el-radio-group>
                                    <template v-if="billConfiguration.isDeductOneHourPrice">
                                        <el-time-picker
                                                v-model="billConfiguration.deductionOneHourBTime"
                                                value-format= "HH:mm"
                                                format= "HH:mm"
                                                placeholder="选择时间"
                                        >
                                        </el-time-picker>
                                        <div class="mar-r-22">~</div>
                                        <el-time-picker
                                                v-model="billConfiguration.deductionOneHourETime"
                                                value-format= "HH:mm"
                                                format= "HH:mm"
                                                placeholder="选择时间">
                                        </el-time-picker>
                                    </template>
                                </div>
                            </el-form-item>
                        </template>
                        <el-row :gutter="24">
                            <el-col :lg="24">
                                <el-form-item label="同城补助：">
                                    <div class="d_flex">
                                        <el-radio-group v-model="commData.citySubsidy" class="mar-r-45">
                                            <el-radio :label="1">无补助</el-radio>
                                            <el-radio :label="3">速派规则</el-radio>
                                            <el-radio :label="4">固定补助</el-radio>
                                        </el-radio-group>
                                        <template v-if="commData.citySubsidy==4">
                                            <el-input  v-model.trim="commData.cityFixedSubsidy" @blur="regulartest('commData.cityFixedSubsidy')"></el-input>
                                            <div>元/天/人</div>
                                        </template>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :lg="24">
                                <el-form-item label="异地补助：" prop="diffCitySubsidy">
                                    <div class="d_flex">
                                        <el-radio-group v-model="commData.diffCitySubsidy" class="mar-r-45">
                                            <el-radio :label="1">无补助</el-radio>
                                            <el-radio :label="3">速派规则</el-radio>
                                            <el-radio :label="4">固定补助</el-radio>
                                        </el-radio-group>
                                        <template v-if="commData.diffCitySubsidy==4">
                                            <el-input v-model.trim="commData.diffCityFixedSubsidy" @blur="regulartest('commData.diffCityFixedSubsidy')"></el-input>
                                            <div>元/天/人</div>
                                        </template>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :lg="24">
                                <el-form-item label="发单方价格：" prop="isTaxIncluded">
                                    <div class="d_flex">
                                        <el-radio-group v-model="commData.isTaxIncluded" class="mar-r-45">
                                            <el-radio :label="true">含税</el-radio>
                                            <el-radio :label="false">不含税</el-radio>
                                        </el-radio-group>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :lg="24">
                                <el-form-item label="特殊地区涨幅：" prop="specialPlaceIncreaseRate">
                                    <div class="d_flex">
                                        <el-radio-group v-model="Increase" class="mar-r-45">
                                            <el-radio :label="0">不涨</el-radio>
                                            <el-radio :label="1">增长</el-radio>
                                        </el-radio-group>
                                        <el-input v-model.trim="commData.specialPlaceIncreaseRate"
                                                  @blur="changeInput(commData.specialPlaceIncreaseRate,'commData.specialPlaceIncreaseRate')"
                                                   :disabled="Increase==0"></el-input>
                                        <div>%</div>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="24">
                            <el-col :lg="24">
                                <el-form-item label="特殊地区：">
                                <span class="area-item" v-for="(item,index) in specialArea" :key="index">
                                    {{item.cityName || item.provinceName}}
                                    <i class="icon-remove" @click="removeDistrict(index)">×</i>
                                </span>
                                    <span class="btn-add el-icon-plus" @click="isShowCascader=true"></span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
            <div class="dialog-footer" style="text-align: center;" slot="footer">
                <el-button type="primary" v-if="Number(Serviceparam.priceSettingType)" @click="comfrimService">确定</el-button>
                <el-button type="primary" v-else @click="comfrimService">下一步</el-button>
            </div>
        </div>
        <el-dialog
                width="500px"
                center
                :visible.sync="isShowCascader"
                :close-on-click-modal="false"
                append-to-body
        >
            <el-form label-width="100">
                <el-form-item label="地址">
                    <el-cascader-panel
                            :options="province"
                            :props="options"
                            ref="cascader"
                            clearable>
                    </el-cascader-panel>
                </el-form-item>
            </el-form>
            <div class="dialog-footer" slot="footer">
                <el-button type="primary" @click="confirmDistrict">确定</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import { getSpecialAreas } from "@/service/dataFrame";
    import { enterpriseVipPriceQuiry,enterpriseVipPriceEdit} from "@/service/customerInformation";
    export default {
        name: "serviceSettings",
        props:{
            currentParam:{
                type:Object,
                default(){return {}}
            }
        },
        data(){
            return{
                setShow:true,
                settleType:0,
                isShowCascader:false,
                billData:{
                    workdayPrice:'', //工作日价格必填
                    vipWorkdayPrice:'',//vip工作日价格必填
                    weekendPrice:'',//周末价格必填
                    vipWeekendPrice:'',//vip周末价格必填
                    holidayPrice:'',//节假日价格必填
                    vipHolidayPrice:'',//vip节假日价格必填
                },
                specialArea:[],
                billConfiguration: {
                    workdayDepartHourPrice: '', //工作日小时 出发 价格，必填
                    workdayWorkHourPrice: '',//工作日小时 工作时价格，//必填
                    workdayBackHourPrice: '', //工作日小时 返回 价格，必填
                    vipWorkdayDepartHourPrice: '', //vip工作日小时 出发 价格，必填
                    vipWorkdayWorkHourPrice: '',//vip工作日小时 工作时价格，//必填
                    vipWorkdayBackHourPrice: '', //vip工作日小时 返回 价格，必填
                    weekendDepartHourPrice: '', //周末小时 出发 价格，必填
                    weekendWorkHourPrice: '',//周末小时 工作时价格，//必填
                    weekendBackHourPrice: '', //周末小时 返回 价格，必填
                    vipWeekendDepartHourPrice: '', //vip周末小时 出发 价格，必填
                    vipWeekendWorkHourPrice: '',//vip周末小时 工作时价格，//必填
                    vipWeekendBackHourPrice: '', //vip周末小时 返回 价格，必填
                    holidayDepartHourPrice: '', //节假日小时 出发 价格，必填
                    holidayWorkHourPrice: '',//节假日小时 工作时价格，//必填
                    holidayBackHourPrice: '', //节假日小时 返回 价格，必填
                    vipHolidayDepartHourPrice: '', //vip节假日小时 出发 价格，必填
                    vipHolidayWorkHourPrice: '',//vip节假日小时 工作时价格，//必填
                    vipHolidayBackHourPrice: '', //vip节假日小时 返回 价格，必填
                    isDeductOneHourPrice:false,//是否扣除1小时价格设置
                    deductionOneHourBTime:'',// 扣除1小时价格开始时间
                    deductionOneHourETime:''//扣除1小时价格终止时间
                },
                commData:{
                    isWorkdayHasOvertimeSetting:false,//是否工作日加班价格设置
                    workdayOverTimeBefore:'',//工作日加班计算什么时间前，isWorkdayHasOvertimeSetting=true必填
                    workdayOverTimeAfter:'',//工作日加班计算什么时间后，isWorkdayHasOvertimeSetting=true必填
                    workdayOverTimeHourPrice:'',//工作日加班价格，isWorkdayHasOvertimeSetting=true必填
                    isWeekendHasOvertimeSetting:false,//是否周末加班价格设置
                    weekendOverTimeBefore:'',//工作日加班计算什么时间前，isWeekendHasOvertimeSetting=true必填
                    weekendOverTimeAfter:'',//周末加班计算什么时间后，isWeekendHasOvertimeSetting=true必填
                    weekendOverTimeHourPrice:'',//周末加班价格，isWeekendHasOvertimeSetting=true必填
                    isHolidayHasOvertimeSetting:false,//是否节假日加班价格设置
                    holidayOverTimeBefore:'',//节假日加班计算什么时间前，isHolidayHasOvertimeSetting=true必填
                    holidayOverTimeAfter:'',//节假日加班计算什么时间后，isHolidayHasOvertimeSetting=true必填
                    holidayOverTimeHourPrice:'',//节假日加班价格，isHolidayHasOvertimeSetting=true必填,
                    citySubsidy:1,
                    diffCitySubsidy:1,
                    cityFixedSubsidy:'',
                    diffCityFixedSubsidy:'',
                    isTaxIncluded:true,
                    specialPlaceIncreaseRate:'',
                },
                Increase:0,//涨幅
                province:[],//省列表
                options:{
                    // multiple: true, //多选
                    checkStrictly: true,//父子节点不相关联
                    emitPath:true,//返回各级节点组成的数组
                    lazy:true,
                    lazyLoad(node,resolve){
                        if(node.level==1){
                            //根据选择的省节点，加载市节点
                            getSpecialAreas(node.value).then(r=>{
                                // console.log(node);
                                if(r.Result==1){
                                    let list=r.Data ||[];
                                    list.map(item=>{
                                        item['label']=item.areaName;
                                        item['value']=item.aid;
                                        item['leaf']=true
                                    })
                                    resolve(list);
                                }else{
                                    resolve([])
                                }
                            })
                        }else{
                            resolve([])
                        }
                    }
                },
                Serviceparam:{},
                loading:false,
                serviceOffer:{},

                send: {
                    billConfigurationDay: null,
                    billConfigurationHour: null,
                },
                sendSettleType: 0,
            }
        },
        methods:{
            setClose(){
                this.$emit("close")
            },
            pageInit(){
                //获取省列表
                getSpecialAreas().then(r=>{
                    if(r.Result==1){
                        let list=r.Data || [];
                        list.map(item=>{
                            item['label']=item.areaName;
                            item['value']=item.aid;
                        })
                        this.province=list;
                    }
                })
            },
            regulartest(name) {
                let arr =name.split('.');
                // 限制只能输入数字
                let value = this[arr[0]][arr[1]].replace(/[^\d.]/g, '');
                // 限制第一个是数字不是小数点
                value = value.replace(/^\./g, "");
                // 限制只能出现一个小数点
                value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
                if(value>99999999.99){
                    this.$message.warning("最大值为99999999.99")
                    value = 99999999.99
                }
                // 重新赋值转换后的值
                this[arr[0]][arr[1]] = value;
            },
            changeTime(value,data1,data2) {
                if (value) {
                    let arr = data1.split('.');
                    let arr2 = data2.split('.');
                    this[arr[0]][arr[1]] = '06:00:00';
                    this[arr2[0]][arr2[1]] = '18:00:00'
                }
            },
            //确认添加特殊地址
            confirmDistrict(){
                let nodes=this.$refs.cascader.getCheckedNodes();
                let node=nodes[0];
                // debugger
                if(node && node.level==1){
                    //选择只有省
                    this.specialArea = this.specialArea.filter(item => {
                        if (item.provinceId != node.value) {
                            return true
                        }
                    })
                    let obj={
                        provinceId:node.value,
                        provinceName:node.label,
                        cityId:0,
                        cityName:'',
                    }
                    // for (var i = 0; i < this.specialArea.length; i++) {
                    //     if (this.specialArea[i].provinceId == node.value){
                    //         this.$message.warning("请勿重复添加地区");
                    //         return
                    //     }
                    // }
                    // console.log(2323232232)
                    this.specialArea.push(obj);
                }
                if (node && node.level==2) {
                    //选择有省和市
                    let obj={
                        provinceId:node.parent.value,
                        provinceName:node.parent.label,
                        cityId:node.value,
                        cityName:node.label,
                    }
                    for (let i = 0; i < this.specialArea.length; i++) {
                        if (this.specialArea[i].provinceId == node.parent.value && this.specialArea[i].cityId == '') {
                            this.$message.warning("请勿重复添加地区");
                            return
                            // this.specialArea.splice(i, 1); //如果已经有省，则删除省
                        }
                        if (this.specialArea[i].cityId == node.value) {
                            this.$message.warning("请勿重复添加地区");
                            return
                            // this.specialArea.splice(i, 1); //如果已经有市，则删除市
                        }
                    }
                    this.specialArea.push(obj);
                }
                this.$refs.cascader.clearCheckedNodes();
                this.isShowCascader=false;
            },
            //删除特殊地址
            removeDistrict(index) {
                this.specialArea.splice(index, 1);
            },
            changeInput(data,name) {
                let arr =name.split('.');
                var o = data.replace(/,/gi, '')
                let rate = 1;
                o = Number(o)
                if (isNaN(o) || parseInt(o) < 1) {
                    rate = 1;
                } else if (parseInt(o) >= 100) {
                    rate = 100;
                } else {
                    rate = Math.floor( o * 100) / 100
                }
                // 重新赋值转换后的值
                this[arr[0]][arr[1]] = rate;
            },
            async getServiceSet(){
                this.loading=true;
                let companyId=Number(this.$route.query.companyId);
                let param ={
                    companyId:companyId,
                    enterpriseVipConfId:this.Serviceparam.enterpriseVipConfId,
                    pagingType:this.Serviceparam.pagingType,
                    serviceOfferId:this.Serviceparam.serviceOfferId,

                    priceSettingType: !Number(this.Serviceparam.priceSettingType)?false:true
                }
                let res = await enterpriseVipPriceQuiry(param)
                this.loading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.serviceOffer = res.Data.bpoServiceOffer;
                if(this.Serviceparam.priceSettingType == 1) {
                    this.settleType = this.sendSettleType;
                }else{
                    this.settleType = res.Data.settleType;
                }
                const dayData  = res.Data.billConfigurationDay;
                if(dayData){
                    this.billData = {
                        workdayPrice: dayData.workdayPrice, //工作日价格必填
                        vipWorkdayPrice: dayData.vipWorkdayPrice,//vip工作日价格必填
                        weekendPrice: dayData.weekendPrice,//周末价格必填
                        vipWeekendPrice: dayData.vipWeekendPrice,//vip周末价格必填
                        holidayPrice: dayData.holidayPrice,//节假日价格必填
                        vipHolidayPrice: dayData.vipHolidayPrice,//vip节假日价格必填
                        id:dayData.id
                    }
                    this.commData = {
                            isWorkdayHasOvertimeSetting:dayData.isWorkdayHasOvertimeSetting,//是否工作日加班价格设置
                            workdayOverTimeBefore:dayData.workdayOverTimeBefore,//工作日加班计算什么时间前，isWorkdayHasOvertimeSetting=true必填
                            workdayOverTimeAfter:dayData.workdayOverTimeAfter,//工作日加班计算什么时间后，isWorkdayHasOvertimeSetting=true必填
                            workdayOverTimeHourPrice:dayData.workdayOverTimeHourPrice,//工作日加班价格，isWorkdayHasOvertimeSetting=true必填
                            isWeekendHasOvertimeSetting:dayData.isWeekendHasOvertimeSetting,//是否周末加班价格设置
                            weekendOverTimeBefore:dayData.weekendOverTimeBefore,//工作日加班计算什么时间前，isWeekendHasOvertimeSetting=true必填
                            weekendOverTimeAfter:dayData.weekendOverTimeAfter,//周末加班计算什么时间后，isWeekendHasOvertimeSetting=true必填
                            weekendOverTimeHourPrice:dayData.weekendOverTimeHourPrice,//周末加班价格，isWeekendHasOvertimeSetting=true必填
                            isHolidayHasOvertimeSetting:dayData.isHolidayHasOvertimeSetting,//是否节假日加班价格设置
                            holidayOverTimeBefore:dayData.holidayOverTimeBefore,//节假日加班计算什么时间前，isHolidayHasOvertimeSetting=true必填
                            holidayOverTimeAfter:dayData.holidayOverTimeAfter,//节假日加班计算什么时间后，isHolidayHasOvertimeSetting=true必填
                            holidayOverTimeHourPrice:dayData.holidayOverTimeHourPrice,//节假日加班价格，isHolidayHasOvertimeSetting=true必填,
                            citySubsidy:dayData.citySubsidy,
                            diffCitySubsidy:dayData.diffCitySubsidy,
                            cityFixedSubsidy:dayData.cityFixedSubsidy,
                            diffCityFixedSubsidy:dayData.diffCityFixedSubsidy,
                            isTaxIncluded:dayData.isTaxIncluded,
                            specialPlaceIncreaseRate:dayData.specialPlaceIncreaseRate,
                    };
                    if(dayData.specialPlaceIncreaseRate>0){
                        this.Increase=1;
                    }else{
                        this.Increase=0;
                    }
                    this.specialArea = dayData.specialPlace || [];
                    // this.settleType = 0;
                }
                const houryData = res.Data.billConfigurationHour;
                if(houryData){
                    this.billConfiguration={
                        id:houryData.id,
                        workdayDepartHourPrice: houryData.workdayDepartHourPrice, //工作日小时 出发 价格，必填
                        workdayWorkHourPrice: houryData.workdayWorkHourPrice,//工作日小时 工作时价格，//必填
                        workdayBackHourPrice: houryData.workdayBackHourPrice, //工作日小时 返回 价格，必填
                        vipWorkdayDepartHourPrice: houryData.vipWorkdayDepartHourPrice, //vip工作日小时 出发 价格，必填
                        vipWorkdayWorkHourPrice: houryData.vipWorkdayWorkHourPrice,//vip工作日小时 工作时价格，//必填
                        vipWorkdayBackHourPrice: houryData.vipWorkdayBackHourPrice, //vip工作日小时 返回 价格，必填
                        weekendDepartHourPrice: houryData.weekendDepartHourPrice, //周末小时 出发 价格，必填
                        weekendWorkHourPrice: houryData.weekendWorkHourPrice,//周末小时 工作时价格，//必填
                        weekendBackHourPrice: houryData.weekendBackHourPrice, //周末小时 返回 价格，必填
                        vipWeekendDepartHourPrice: houryData.vipWeekendDepartHourPrice, //vip周末小时 出发 价格，必填
                        vipWeekendWorkHourPrice: houryData.vipWeekendWorkHourPrice,//vip周末小时 工作时价格，//必填
                        vipWeekendBackHourPrice: houryData.vipWeekendBackHourPrice, //vip周末小时 返回 价格，必填
                        holidayDepartHourPrice: houryData.holidayDepartHourPrice, //节假日小时 出发 价格，必填
                        holidayWorkHourPrice: houryData.holidayWorkHourPrice,//节假日小时 工作时价格，//必填
                        holidayBackHourPrice: houryData.holidayBackHourPrice, //节假日小时 返回 价格，必填
                        vipHolidayDepartHourPrice: houryData.vipHolidayDepartHourPrice, //vip节假日小时 出发 价格，必填
                        vipHolidayWorkHourPrice: houryData.vipHolidayWorkHourPrice,//vip节假日小时 工作时价格，//必填
                        vipHolidayBackHourPrice: houryData.vipHolidayBackHourPrice, //vip节假日小时 返回 价格，必填
                        isDeductOneHourPrice: houryData.isDeductOneHourPrice,//是否扣除1小时价格设置
                        deductionOneHourBTime: houryData.deductionOneHourBTime,// 扣除1小时价格开始时间
                        deductionOneHourETime: houryData.deductionOneHourETime//扣除1小时价格终止时间
                    };
                    this.commData = {
                        isWorkdayHasOvertimeSetting:houryData.isWorkdayHasOvertimeSetting,//是否工作日加班价格设置
                        workdayOverTimeBefore:houryData.workdayOverTimeBefore,//工作日加班计算什么时间前，isWorkdayHasOvertimeSetting=true必填
                        workdayOverTimeAfter:houryData.workdayOverTimeAfter,//工作日加班计算什么时间后，isWorkdayHasOvertimeSetting=true必填
                        workdayOverTimeHourPrice:houryData.workdayOverTimeHourPrice,//工作日加班价格，isWorkdayHasOvertimeSetting=true必填
                        isWeekendHasOvertimeSetting:houryData.isWeekendHasOvertimeSetting,//是否周末加班价格设置
                        weekendOverTimeBefore:houryData.weekendOverTimeBefore,//工作日加班计算什么时间前，isWeekendHasOvertimeSetting=true必填
                        weekendOverTimeAfter:houryData.weekendOverTimeAfter,//周末加班计算什么时间后，isWeekendHasOvertimeSetting=true必填
                        weekendOverTimeHourPrice:houryData.weekendOverTimeHourPrice,//周末加班价格，isWeekendHasOvertimeSetting=true必填
                        isHolidayHasOvertimeSetting:houryData.isHolidayHasOvertimeSetting,//是否节假日加班价格设置
                        holidayOverTimeBefore:houryData.holidayOverTimeBefore,//节假日加班计算什么时间前，isHolidayHasOvertimeSetting=true必填
                        holidayOverTimeAfter:houryData.holidayOverTimeAfter,//节假日加班计算什么时间后，isHolidayHasOvertimeSetting=true必填
                        holidayOverTimeHourPrice:houryData.holidayOverTimeHourPrice,//节假日加班价格，isHolidayHasOvertimeSetting=true必填,
                        citySubsidy:houryData.citySubsidy,
                        diffCitySubsidy:houryData.diffCitySubsidy,
                        cityFixedSubsidy:houryData.cityFixedSubsidy,
                        diffCityFixedSubsidy:houryData.diffCityFixedSubsidy,
                        isTaxIncluded:houryData.isTaxIncluded,
                        specialPlaceIncreaseRate:houryData.specialPlaceIncreaseRate,
                    };
                    if(houryData.specialPlaceIncreaseRate>0){
                        this.Increase=1;
                    }else{
                        this.Increase=0;
                    }
                    this.specialArea = houryData.specialPlace || [];
                    // this.settleType = 1;
                }
                // console.log("res",res)
            },
            comfrimService(){
                if (this.settleType == 0) {
                    // if (this.billData.workdayPrice === "" || this.billData.vipWorkdayPrice === "" || this.billData.weekendPrice === "" ||
                    //     this.billData.vipWeekendPrice === "" || this.billData.holidayPrice === "" || this.billData.vipHolidayPrice === "") {
                    //     this.$message.warning("请填写所有必填项")
                    //     return
                    // }
                    // if (this.billData.workdayPrice === null || this.billData.vipWorkdayPrice === null || this.billData.weekendPrice === null ||
                    //     this.billData.vipWeekendPrice === null || this.billData.holidayPrice === null || this.billData.vipHolidayPrice === null) {
                    //     this.$message.warning("请填写所有必填项")
                    //     return
                    // }
                    if (this.billData.workdayPrice === "" ||
                        this.billData.weekendPrice === "" || 
                        this.billData.holidayPrice === "") {
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                    if (this.billData.workdayPrice === null ||
                        this.billData.weekendPrice === null ||
                        this.billData.holidayPrice === null) {
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                } else {
                    // if (this.billConfiguration.workdayDepartHourPrice === "" || this.billConfiguration.workdayWorkHourPrice === "" || this.billConfiguration.workdayBackHourPrice === "" ||
                    //     this.billConfiguration.vipWorkdayDepartHourPrice === "" || this.billConfiguration.vipWorkdayWorkHourPrice === "" || this.billConfiguration.vipWorkdayBackHourPrice === "" ||
                    //     this.billConfiguration.weekendDepartHourPrice === "" || this.billConfiguration.weekendWorkHourPrice === "" || this.billConfiguration.weekendBackHourPrice === "" ||
                    //     this.billConfiguration.vipWeekendDepartHourPrice === "" || this.billConfiguration.vipWeekendWorkHourPrice === "" || this.billConfiguration.vipWeekendBackHourPrice === "" ||
                    //     this.billConfiguration.holidayDepartHourPrice === "" || this.billConfiguration.holidayWorkHourPrice === "" || this.billConfiguration.holidayBackHourPrice === "" ||
                    //     this.billConfiguration.vipHolidayDepartHourPrice === "" || this.billConfiguration.vipHolidayWorkHourPrice === "" || this.billConfiguration.vipHolidayBackHourPrice === "") {
                    //     this.$message.warning("请填写所有必填项")
                    //     return
                    // }
                    // if (this.billConfiguration.workdayDepartHourPrice === null || this.billConfiguration.workdayWorkHourPrice === null || this.billConfiguration.workdayBackHourPrice === null ||
                    //     this.billConfiguration.vipWorkdayDepartHourPrice === null || this.billConfiguration.vipWorkdayWorkHourPrice === null || this.billConfiguration.vipWorkdayBackHourPrice === null ||
                    //     this.billConfiguration.weekendDepartHourPrice === null || this.billConfiguration.weekendWorkHourPrice === null || this.billConfiguration.weekendBackHourPrice === null ||
                    //     this.billConfiguration.vipWeekendDepartHourPrice === null || this.billConfiguration.vipWeekendWorkHourPrice === null || this.billConfiguration.vipWeekendBackHourPrice === null ||
                    //     this.billConfiguration.holidayDepartHourPrice === null || this.billConfiguration.holidayWorkHourPrice === null || this.billConfiguration.holidayBackHourPrice === null ||
                    //     this.billConfiguration.vipHolidayDepartHourPrice === null || this.billConfiguration.vipHolidayWorkHourPrice === null || this.billConfiguration.vipHolidayBackHourPrice === null) {
                    //     this.$message.warning("请填写所有必填项")
                    //     return
                    // }
                    if (this.billConfiguration.workdayDepartHourPrice === "" ||
                        this.billConfiguration.workdayWorkHourPrice === "" ||
                        this.billConfiguration.workdayBackHourPrice === "" ||
                        this.billConfiguration.weekendDepartHourPrice === "" ||
                        this.billConfiguration.weekendWorkHourPrice === "" || 
                        this.billConfiguration.weekendBackHourPrice === "" ||
                        this.billConfiguration.holidayDepartHourPrice === "" || 
                        this.billConfiguration.holidayWorkHourPrice === "" || 
                        this.billConfiguration.holidayBackHourPrice === "") {
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                    if (this.billConfiguration.workdayDepartHourPrice === null ||
                        this.billConfiguration.workdayWorkHourPrice === null ||
                        this.billConfiguration.workdayBackHourPrice === null ||
                        this.billConfiguration.weekendDepartHourPrice === null || 
                        this.billConfiguration.weekendWorkHourPrice === null || 
                        this.billConfiguration.weekendBackHourPrice === null ||
                        this.billConfiguration.holidayDepartHourPrice === null || 
                        this.billConfiguration.holidayWorkHourPrice === null || 
                        this.billConfiguration.holidayBackHourPrice === null) {
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                    if(this.billConfiguration.isDeductOneHourPrice) {
                        if (!this.billConfiguration.deductionOneHourBTime || !this.billConfiguration.deductionOneHourETime) {
                            this.$message.warning("请填写所有必填项")
                            return
                        }
                    }
                }
                if(this.commData.isWorkdayHasOvertimeSetting){
                    if(this.commData.workdayOverTimeBefore===""||this.commData.workdayOverTimeAfter===""||this.commData.workdayOverTimeHourPrice===""){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                    if(this.commData.workdayOverTimeBefore===null||this.commData.workdayOverTimeAfter===null||this.commData.workdayOverTimeHourPrice===null){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                }
                if(this.commData.isWeekendHasOvertimeSetting){
                    if(this.commData.weekendOverTimeBefore===""||this.commData.weekendOverTimeAfter===""||this.commData.weekendOverTimeHourPrice===""){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                    if(this.commData.weekendOverTimeBefore===null||this.commData.weekendOverTimeAfter===null||this.commData.weekendOverTimeHourPrice===null){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                }
                if(this.commData.isHolidayHasOvertimeSetting){
                    if(this.commData.holidayOverTimeBefore===""||this.commData.holidayOverTimeAfter===""||this.commData.holidayOverTimeHourPrice===""){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                    if(this.commData.weekendOverTimeBefore===null||this.commData.weekendOverTimeAfter===null||this.commData.weekendOverTimeHourPrice===null){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                }
                if(this.commData.citySubsidy==4){
                    if(this.commData.cityFixedSubsidy===""||this.commData.cityFixedSubsidy===null){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                }
                if(this.commData.diffCitySubsidy==4){
                    if(this.commData.diffCityFixedSubsidy===""||this.commData.diffCityFixedSubsidy===null){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                }
                if(this.Increase==1){
                    if(this.commData.specialPlaceIncreaseRate===''||this.commData.specialPlaceIncreaseRate===null){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                    if(!this.specialArea.length){
                        this.$message.warning("请填写所有必填项")
                        return
                    }
                }
                
                
                //发单 每天
                let billData = this.billData;
                let billConfiguration = this.billConfiguration;
                let commData = this.commData;
                let billConfig = {};
                if(this.settleType==0){
                    billConfig = {
                        citySubsidy:commData.citySubsidy,
                        diffCitySubsidy:commData.diffCitySubsidy,
                        isHolidayHasOvertimeSetting:commData.isHolidayHasOvertimeSetting,
                        isTaxIncluded:commData.isTaxIncluded,
                        isWeekendHasOvertimeSetting:commData.isWeekendHasOvertimeSetting,
                        isWorkdayHasOvertimeSetting:commData.isWorkdayHasOvertimeSetting,
                        specialPlace:this.specialArea,
                        specialPlaceIncreaseRate:commData.specialPlaceIncreaseRate,
                        vipHolidayPrice:billData.vipHolidayPrice,
                        vipWeekendPrice:billData.vipWeekendPrice,
                        vipWorkdayPrice:billData.vipWorkdayPrice,
                        workdayPrice:billData.workdayPrice,
                        weekendPrice:billData.weekendPrice,
                        holidayPrice:billData.holidayPrice
                    }
                }else{
                    billConfig = {
                        citySubsidy:commData.citySubsidy,
                        diffCitySubsidy:commData.diffCitySubsidy,
                        isHolidayHasOvertimeSetting:commData.isHolidayHasOvertimeSetting,
                        isTaxIncluded:commData.isTaxIncluded,
                        isWeekendHasOvertimeSetting:commData.isWeekendHasOvertimeSetting,
                        isWorkdayHasOvertimeSetting:commData.isWorkdayHasOvertimeSetting,
                        specialPlace:this.specialArea,
                        specialPlaceIncreaseRate:commData.specialPlaceIncreaseRate,
                        workdayDepartHourPrice:billConfiguration.workdayDepartHourPrice, //工作日小时 出发 价格，必填
                        workdayWorkHourPrice:billConfiguration.workdayWorkHourPrice,//工作日小时 工作时价格，//必填
                        workdayBackHourPrice:billConfiguration.workdayBackHourPrice, //工作日小时 返回 价格，必填
                        vipWorkdayDepartHourPrice:billConfiguration.vipWorkdayDepartHourPrice, //vip工作日小时 出发 价格，必填
                        vipWorkdayWorkHourPrice:billConfiguration.vipWorkdayWorkHourPrice,//vip工作日小时 工作时价格，//必填
                        vipWorkdayBackHourPrice:billConfiguration.vipWorkdayBackHourPrice, //vip工作日小时 返回 价格，必填
                        weekendDepartHourPrice:billConfiguration.weekendDepartHourPrice, //周末小时 出发 价格，必填
                        weekendWorkHourPrice:billConfiguration.weekendWorkHourPrice,//周末小时 工作时价格，//必填
                        weekendBackHourPrice:billConfiguration.weekendBackHourPrice, //周末小时 返回 价格，必填
                        vipWeekendDepartHourPrice:billConfiguration.vipWeekendDepartHourPrice, //vip周末小时 出发 价格，必填
                        vipWeekendWorkHourPrice:billConfiguration.vipWeekendWorkHourPrice,//vip周末小时 工作时价格，//必填
                        vipWeekendBackHourPrice:billConfiguration.vipWeekendBackHourPrice, //vip周末小时 返回 价格，必填
                        holidayDepartHourPrice:billConfiguration.holidayDepartHourPrice, //节假日小时 出发 价格，必填
                        holidayWorkHourPrice:billConfiguration.holidayWorkHourPrice,//节假日小时 工作时价格，//必填
                        holidayBackHourPrice:billConfiguration.holidayBackHourPrice, //节假日小时 返回 价格，必填
                        vipHolidayDepartHourPrice:billConfiguration.vipHolidayDepartHourPrice, //vip节假日小时 出发 价格，必填
                        vipHolidayWorkHourPrice:billConfiguration.vipHolidayWorkHourPrice,//vip节假日小时 工作时价格，//必填
                        vipHolidayBackHourPrice:billConfiguration.vipHolidayBackHourPrice, //vip节假日小时 返回 价格，必填
                        isDeductOneHourPrice:billConfiguration.isDeductOneHourPrice,//是否扣除1小时价格设置
                    }
                    if(billConfiguration.isDeductOneHourPrice){
                        billConfig.deductionOneHourBTime = billConfiguration.deductionOneHourBTime;
                        billConfig.deductionOneHourETime = billConfiguration.deductionOneHourETime;
                    }
                }
                //工作日加班
                if(commData.isWorkdayHasOvertimeSetting){
                    billConfig.workdayOverTimeBefore = commData.workdayOverTimeBefore;
                    billConfig.workdayOverTimeAfter = commData.workdayOverTimeAfter;
                    billConfig.workdayOverTimeHourPrice = commData.workdayOverTimeHourPrice;
                }
                //周末加班
                if(commData.isWeekendHasOvertimeSetting){
                    billConfig.weekendOverTimeBefore = commData.weekendOverTimeBefore;
                    billConfig.weekendOverTimeAfter = commData.weekendOverTimeAfter;
                    billConfig.weekendOverTimeHourPrice = commData.weekendOverTimeHourPrice;
                }
                if(commData.isHolidayHasOvertimeSetting){
                    billConfig.holidayOverTimeBefore = commData.holidayOverTimeBefore;
                    billConfig.holidayOverTimeAfter = commData.holidayOverTimeAfter;
                    billConfig.holidayOverTimeHourPrice = commData.holidayOverTimeHourPrice;
                }
                if(commData.citySubsidy==4){
                    billConfig.cityFixedSubsidy = commData.cityFixedSubsidy;
                }
                if(commData.diffCitySubsidy==4){
                    billConfig.diffCityFixedSubsidy = commData.diffCityFixedSubsidy;
                }
                let companyId=Number(this.$route.query.companyId);
                let param ={
                    companyId:companyId,
                    pagingType:this.Serviceparam.pagingType,
                    serviceOfferId:this.Serviceparam.serviceOfferId,
                    // confPriceId:this.Serviceparam.confPriceId,
                    settleType:this.settleType,
                    enterpriseVipConfId:this.Serviceparam.enterpriseVipConfId
                }
                if (!Number(this.Serviceparam.priceSettingType)) {
                    if (this.settleType==0){
                        this.send.billConfigurationDay = billConfig;
                    }
                    if (this.settleType==1){
                        this.send.billConfigurationHour = billConfig;
                    }
                    this.sendSettleType = this.settleType
                    this.Serviceparam.priceSettingType = '1'
                    this.getServiceSet();
                    return 
                }
                if (this.settleType==0){
                    param.billConfigurationDay = this.send.billConfigurationDay;
                    param.orderTakingBillConfigurationDay = billConfig
                    param.confPriceId=billData.id?billData.id:this.serviceOffer.id
                    // console.log('天',param)
                }
                if (this.settleType==1){
                    param.billConfigurationHour = this.send.billConfigurationHour;
                    param.orderTakingBillConfigurationHour = billConfig
                    param.confPriceId=billConfiguration.id?billConfiguration.id:this.serviceOffer.id
                    // console.log('小时',param)
                }
                // if (this.settleType==0){
                //     param.billConfigurationDay = billConfig;
                //     param.confPriceId=billData.id?billData.id:this.serviceOffer.id
                // }
                // if (this.settleType==1){
                //     param.billConfigurationHour = billConfig;
                //     param.confPriceId=billConfiguration.id?billConfiguration.id:this.serviceOffer.id
                // }
                
                this.loading=true;
                enterpriseVipPriceEdit(param).then((res)=>{
                    this.loading=false;
                    if(res.Result != 1) {
                        return this.$message.error('获取失败请联系开发人员')
                    }
                    this.$message.success("设置成功")
                    this.$emit("close")
                    this.$emit("refreshList")
                })
            }
        },
        created() {
            this.pageInit();
            if (this.currentParam){
                const param = JSON.parse(JSON.stringify(this.currentParam));
                param.priceSettingType = 0
                this.Serviceparam = param;
                this.getServiceSet();
            }
        }
    }
</script>

<style lang="scss">
    .ServiceSetting{
        .Set {
            position: relative;
            padding: 4px;
            // max-height: 700px;
            overflow-y: auto;
            overflow-x: hidden;
            &::-webkit-scrollbar {
                /*滚动条整体样式*/
                width: 6px;
                /*高宽分别对应横竖滚动条的尺寸*/
                height: 1px;
                box-shadow: none;
                background: transparent;
            }

            &::-webkit-scrollbar-thumb {
                /*滚动条里面小方块*/
                border-radius: 6px;
                padding: 2px;
                box-shadow: none;
                background: rgba(229, 229, 229, 1);
            }

            &::-webkit-scrollbar-track {
                /*滚动条里面轨道*/
                border-radius: 10px;
                box-shadow: none;
                background: transparent;
            }
            .Set-top {
                .d-title {
                    font-size: 34px;
                    font-weight: 400;
                    color: #333333;
                    width: 70%;
                }
            }
            .Set-center {
                margin-top: 39px;
                max-width: 1120px;

                table {
                    border-collapse: collapse;
                    font-size: 19px;
                }

                td {
                    width: 182px;
                    height: 52px;
                    background: #FFFFFF;
                    text-align: center;
                    /*line-height: 52px;*/
                    border: 1px solid #E5E5E5;
                }

                .desc {
                    font-size: 16px;
                }

                .ourrow {
                    .el-col {
                        padding-left: 0px !important;
                        padding-right: 0px !important;
                        word-break: break-all;
                    }
                }
            }
            .Set-bottom{
                .el-input{
                    width: 144px;
                    margin-right: 18px;
                }
                .el-input__inner{
                    width: 144px;
                    height: 38px;
                }
                .d_flex{
                    display: flex;
                    align-items: center;
                    height: 40px;
                }
                .area-item{
                    position: relative;
                    display: inline-block;
                    vertical-align: middle;
                    line-height: 26px;
                    background-color: rgba(45, 140, 239, 0.4);
                    margin-right: 26px;
                    color: #2D8CEF;
                    /*width: 68px;*/
                    padding: 0px 20px;
                    height: 26px;
                    text-align: center;
                    font-size: 14px;
                    &:hover{
                        cursor: pointer;
                        .icon-remove{
                            display: block;
                        }
                    }
                    .icon-remove{
                        position: absolute;
                        right: 0;
                        top: 0;
                        width: 20px;
                        height: 20px;
                        line-height: 20px;
                        text-align: center;
                        font-size: 14px;
                        color: #fff;
                        cursor: pointer;
                        display: none;
                    }
                }
                .btn-add{
                    position: relative;
                    display: inline-block;
                    vertical-align: middle;
                    width: 68px;
                    height: 26px;
                    line-height: 26px;
                    text-align: center;
                    border: 1px solid #2D8CEF;;
                    background-color: #fff;
                    box-sizing: border-box;
                    cursor: pointer;
                    font-size: 16px;
                    color: #2D8CEF;
                    &:hover{
                        background-color: #2D8CEF;
                        color: #fff;
                    }
                }
            }
            .mar-r-22{
                margin-right:22px;
            }
            .mar-r-45{
                margin-right: 45px;
            }
        }
    }
</style>
